import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { CloseIcon, IconButton, Tooltip } from "@activecollab/components";
import PropTypes from "prop-types";
import DeleteTemplateElementDialog from "../../DeleteTemplateElementDialog";
import { PROJECT_TEMPLATE_SUBTASK } from "../../utils";

export const TemplateSubtaskDelete = ({ subtask }) => {
  const { t } = useTranslation();

  const [deleteElementId, setDeleteElementId] = useState(null);

  const handleOpen = useCallback(() => {
    setDeleteElementId(subtask.id);
  }, [subtask.id]);

  return (
    <>
      <Tooltip title={t("Delete Subtask")}>
        <IconButton
          variant="text gray"
          onClick={handleOpen}
        >
          <CloseIcon />
        </IconButton>
      </Tooltip>
      {deleteElementId ? (
        <DeleteTemplateElementDialog
          type={PROJECT_TEMPLATE_SUBTASK}
          deleteElementId={deleteElementId}
          setDeleteElementId={setDeleteElementId}
          templateId={subtask.template_id}
          disableRedirect
        />
      ) : null}
    </>
  );
};

TemplateSubtaskDelete.propTypes = {
  subtask: PropTypes.object,
};
